var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4378_10183)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 5,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0.5C2.29086 0.5 0.5 2.29086 0.5 4.5C0.5 6.70914 2.29086 8.5 4.5 8.5C6.70914 8.5 8.5 6.70914 8.5 4.5C8.49761 2.29184 6.70816 0.502391 4.5 0.5ZM5.83333 5.36233C5.96878 5.487 5.97753 5.69788 5.85286 5.83333C5.72819 5.96878 5.51731 5.97753 5.38186 5.85286C5.37508 5.84663 5.36858 5.84011 5.36233 5.83333L4.5 4.97133L3.638 5.83333C3.50558 5.96122 3.29456 5.95755 3.16667 5.82513C3.04192 5.69595 3.04192 5.49117 3.16667 5.362L4.02867 4.5L3.16667 3.638C3.03878 3.50558 3.04245 3.29456 3.17488 3.16667C3.30405 3.04192 3.50883 3.04192 3.638 3.16667L4.5 4.02867L5.36233 3.16667C5.487 3.03122 5.69788 3.02247 5.83333 3.14714C5.96878 3.27181 5.97753 3.48269 5.85286 3.61814C5.84663 3.62492 5.84011 3.63142 5.83333 3.63767L4.97133 4.5L5.83333 5.36233Z",
    fill: "#FF434E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4378_10183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossRed);
export default __webpack_public_path__ + "static/media/cross-red.5e5b94da4cf6934aaa85dfb865ab1e3f.svg";
export { ForwardRef as ReactComponent };